import { render, staticRenderFns } from "./agritainment.vue?vue&type=template&id=b14643b0&"
import script from "./agritainment.vue?vue&type=script&lang=js&"
export * from "./agritainment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "agritainment.vue"
export default component.exports